import * as React from 'react';

import BoxMobile140 from './BoxMobile140';

export const boxMobile140 = () => <BoxMobile140 />;

export default {
    title: 'Illustration|BoxMobile140',
    component: BoxMobile140,
    parameters: {
        notes: "`import BoxMobile140 from 'box-ui-elements/es/illustration/BoxMobile140';`",
    },
};
